<template>
  <ba-dialog
    :save="save"
    :title="$t('_connectFoundry')"
    :canSave="!canSave"
    :show-button="false"
    :show="showDialog"
    :onHide="hideDialog"
  >
    <v-container fluid grid-list-xl>
      <v-layout wrap>
        <v-flex xs12 sm12 md6 lg6>
          <p>
            We recommend that the API credentials you are sharing with us be
            <b>read-only</b>.
          </p>
          <v-text-field label="X-API-Key" v-model="xApiKey"></v-text-field>
          <v-text-field label="Sub-Account Name" v-model="subAccountName"></v-text-field>
          <v-checkbox label="Recognize FPPS On Day Earned" v-model="useFppsDayEarned"></v-checkbox>
          <v-autocomplete
            v-model="exchangeContactId"
            :items="contacts"
            :label="$t('_exchangeContact')"
            item-text="name"
            item-value="id"
            persistent-hint
          ></v-autocomplete>
          <v-btn :disabled="!canValidate" @click="validate" :loading="isValidating">{{ $t('_validate') }}</v-btn>
        </v-flex>

        <v-flex xs6 v-if="canValidate">
          <validation-summary
            ref="connectionValidation"
            :validation-data="validationData"
            account-type="Foundry Connection"
          />
        </v-flex>
      </v-layout>

      <v-layout v-if="errorMessage" wrap align-center>
        <v-flex xs12 class="tw-text-red-400">
          {{ errorMessage }}
        </v-flex>
      </v-layout>
    </v-container>
  </ba-dialog>
</template>

<script>
import gql from 'graphql-tag';

import ValidationSummary from '@/components/validation/AccountValidationSummary';

export default {
  components: { ValidationSummary },
  props: ['refresh'],
  data() {
    return {
      xApiKey: '',
      subAccountName: '',
      showDialog: false,
      exchangeContactId: '',
      errorMessage: null,
      validationData: null,
      isValid: false,
      isValidating: false,
      useFppsDayEarned: false,
    };
  },
  computed: {
    canValidate() {
      return this.xApiKey && this.subAccountName;
    },
    canSave() {
      return this.xApiKey && this.subAccountName && this.exchangeContactId && this.isValid && !this.isValidating;
    },
    contacts() {
      return this.$store.getters['contacts/ENABLED_CONTACTS'];
    },
  },
  watch: {
    showDialog() {
      if (this.showDialog) {
        this.resetForm();
      }
    },
  },
  methods: {
    resetForm() {
      this.xApiKey = '';
      this.subAccountName = '';
      this.exchangeContactId = '';
      this.errorMessage = null;
      this.isValidating = false;
    },
    hideDialog() {
      this.showDialog = false;
      this.resetForm();
    },
    show() {
      this.showDialog = true;
    },
    async validate() {
      try {
        this.isValidating = true;
        const vars = {
          createFoundry: {
            xApiKey: this.xApiKey,
            subAccountName: this.subAccountName,
            exchangeContactId: this.exchangeContactId,
            flags: {
              useFppsDayEarned: this.useFppsDayEarned,
            },
          },
        };
        const validation = await this.$refs.connectionValidation.validate(vars);
        this.isValid = validation.success;
        this.isValidating = false;
      } catch (error) {
        this.isValid = false;
        this.isValidating = false;
      }
    },
    async save() {
      // reset error message
      this.errorMessage = null;

      const vars = {
        orgId: this.$store.state.currentOrg.id,
        create: {
          name: `Foundy [${this.subAccountName.toUpperCase()}]`,
          createFoundry: {
            xApiKey: this.xApiKey,
            subAccountName: this.subAccountName,
            exchangeContactId: this.exchangeContactId,
            flags: {
              useFppsDayEarned: this.useFppsDayEarned,
            },
          },
        },
      };

      return await this.$apollo
        .mutate({
          // Query
          mutation: gql`
            mutation CreateConnection($orgId: ID!, $create: CreateConnectionInput!) {
              createConnection(orgId: $orgId, create: $create) {
                success
                errors
                message
              }
            }
          `,
          // Parameters
          variables: vars,
        })
        .catch((err) => {
          const errors = err.graphQLErrors.map((e) => e.message);
          this.errorMessage = '* ' + errors[0];
        })
        .then(() => {
          if (this.errorMessage) {
            return { error: this.errorMessage };
          } else {
            this.resetForm();

            if (this.refresh) {
              this.refresh();
            }

            this.showDialog = false;
          }
        });
    },
  },
};
</script>
